<p-table #AllTaskList [value]="taskResult" sortMode="multiple" [autoLayout]="true" [loading]="loading"
  [paginator]="true" [responsive]="true" [rows]="rowlimit" [rowsPerPageOptions]="[10,25,50,100]"
  [tableStyle]="{ 'min-width': '50rem' }" [globalFilterFields]="['EventNameWithUnitLabel']"
  [totalRecords]="totalRecords" paginatorPosition="both" (onLazyLoad)="loadPaginatedData($event)" [lazy]="true"
  [lazyLoadOnInit]="false" [resetPageOnSort]="false">
  <ng-template pTemplate="caption">
    <div class="search-container">
      <span class="fa fa-file-excel-o" style="font-size: 1.5em"></span>&nbsp;
      <a href="{{exportExcel()}}" class="excelLink">Download To Excel</a>&nbsp;&nbsp;
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th [pSortableColumn]="'LoanNumber'">LoanNumber
        <p-sortIcon [field]="'LoanNumber'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'EventName'">Task Name
        <p-sortIcon [field]="'EventName'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'Address?.Address1'" pResizableColumn>Address
        <p-sortIcon [field]="'Address?.Address1'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'AssignedPersonFirstName'">Person
        <p-sortIcon [field]="'AssignedPersonFirstName'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'AssignedRoleName'">Role
        <p-sortIcon [field]="'AssignedRoleName'"></p-sortIcon>
      </th>

      <th [pSortableColumn]="'CloseOperatorFirstName'">Completed By
        <p-sortIcon [field]="'CloseOperatorFirstName'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'OpenDate'">Open Date
        <p-sortIcon [field]="'OpenDate'"></p-sortIcon>
      </th>
      <th [pSortableColumn]="'CloseDate'">Due/Completed
        <p-sortIcon [field]="'CloseDate'"></p-sortIcon>
      </th>
    </tr>

  </ng-template>

  <ng-template pTemplate="body" let-taskResult let-rowData let-rowIndex="rowIndex">
    <tr class="ui-widget-header" *ngIf="rowGroupMetadata[rowData.LenderPublicName].index === rowIndex">
      <td colspan="3">
        <span style="font-weight:bold">{{taskResult.LenderPublicName}}</span>
      </td>
    </tr>
    <tr>
      <td><a class="iconNewWindow" target="_blank"
          href="{{propertyUrl(taskResult.PropertyId)}}">{{taskResult.LoanNumber}}</a></td>
      <td>
        {{taskResult.EventName}}
        {{extendedEventName(taskResult?.UnitLabel,taskResult?.OtherEventTypeGroup,tasks?.OtherEventTypeLabel,taskResult?.SequenceNumber)}}
      </td>
      <td>
        {{taskResult.Address?.Address1}} {{taskResult.Address?.Address2}}, {{taskResult.Address?.City}},
        {{taskResult.Address?.State}}
      </td>
      <td>{{taskResult?.AssignedPersonFirstName}}.{{taskResult?.AssignedPersonLastName}}</td>
      <td>{{taskResult.AssignedRoleName}}</td>
      <td>{{completedBy(taskResult?.CloseOperatorFirstName,taskResult?.CloseOperatorLastName)}}</td>
      <td>{{taskResult?.OpenDate | dateTimeFormat:'MM/dd/yyyy h:mm'}}</td>
      <td [class]="getStatusClass(taskResult.TaskStatusId)">
        {{taskResult?.DueDate | dateTimeFormat:'MM/dd/yyyy h:mm'}} ({{taskResult?.DaysToClose}})
        {{getDueCompleteSuffix(taskResult)}}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="paginatorright" let-state>
    Showing {{state.first}} to {{state.first + state.rows}} of {{state.totalRecords}} entries
  </ng-template>
</p-table>